import React, { useState } from 'react';
import Form from 'global/components/form';
import { get } from '../../../global/lib/lodash';
import useStyles from './styles';
import { Column, Row } from '../../../global/components/row';
import { Button } from '../../../global/components/Button';
import { _size } from 'global/utils';
import sendData from 'redux/actions/sendData';
import SnackAlerts from '../../../global/components/snack-alerts';
import { fixMinus } from './create-scorecard';
import colors from 'global/styles/colors';

export const EditScorecard = (props) => {
  const classes = useStyles();
  const [alerts, setAlerts] = useState();
  const [fs, setfs] = useState({});
  const [state, setState] = useState({
    loading: false,
  });

  const onSubmit = async () => {
    try {
      setState((s) => ({ ...s, loading: true }));

      const scid = get(props, 'scorecard.id');

      const data = {
        data: {
          id: scid,
          type: 'scorecards',
          attributes: fixMinus(fs),
        }
      };

      const resp = await sendData({
        url: `/scorecards/${scid}`,
        method: 'patch',
        data,
      }, { simulate: false });

      props.onClose && props.onClose(true);
    } catch (err) {
      setAlerts({ message: err.message, severity: 'error' });
    } finally {
      setState((s) => ({ ...s, loading: false }));
    }
  };

  return (
    <div className={classes.createSc}>
      <Column center fullWidth>
        <div style={{ width: '100%', marginBottom: 34 }}>
          <Form
            onFormState={setfs}
            loading={state.loading}
            showAllScreens
            screens={[
              {
                title: 'General Information',
                inputs: [
                  {
                    id: 'name',
                    type: 'TextField',
                    defaultValue: () => get(props, 'scorecard.name', ''),
                    required: true,
                    props: {
                      label: 'Name',
                    },
                  },
                  {
                    id: 'active',
                    type: 'Select',
                    defaultValue: () => get(props, 'scorecard.active', 0) === 0 ? -1 : 1,
                    data: [
                      { value: 1, title: 'True' },
                      { value: -1, title: 'False' },
                    ],
                    props: {
                      label: 'Active',
                    },
                  },
                ]
              }
            ]}
          />
        </div>

        <Row center className={classes.buttonRowModal} style={{ justifyContent: 'center' }}>
          <Button icon="close" bgColor={colors.danger} onClick={() => props.onClose()}>
            CANCEL
          </Button>
          <Button disabled={!fs.name} icon="save" onClick={() => onSubmit()}>
            SAVE
          </Button>
        </Row>

        <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
      </Column>
    </div>
  );
};